import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  FaBriefcase, 
  FaPhotoVideo, 
  FaDollarSign, 
  FaCreditCard,
  FaGlobe,
  FaHome
} from 'react-icons/fa';
import { INFLUENCER_BASE } from '../constants';

const BottomNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Navigation items matching the requirements
  const navItems = [
    {
      id: 'dashboard',
      label: 'Home',
      icon: FaHome,
      path: `${INFLUENCER_BASE}/dashboard`,
      color: '#3B82F6'
    },
    {
      id: 'campaign',
      label: 'Campaign',
      icon: FaBriefcase,
      path: `${INFLUENCER_BASE}/dashboard/affiliate-dashboard`,
      color: '#3B82F6' // Blue color like in the reference
    },
    {
      id: 'social-media',
      label: 'Social',
      icon: FaGlobe,
      path: `${INFLUENCER_BASE}/dashboard/connect-social-media`,
      color: '#3B82F6'
    },
    {
      id: 'insta-media-dashboard',
      label: 'Media',
      icon: FaPhotoVideo,
      path: `${INFLUENCER_BASE}/dashboard/insta-media-dashboard`,
      color: '#3B82F6' // Gray color for inactive items
    },
    {
      id: 'earning',
      label: 'Earnings',
      icon: FaDollarSign,
      path: `${INFLUENCER_BASE}/dashboard/earnings`,
      color: '#3B82F6'
    },
    {
      id: 'pricing',
      label: 'Pricing',
      icon: FaCreditCard,
      path: `${INFLUENCER_BASE}/dashboard/service-payment`,
      color: '#3B82F6'
    }
  ];

  // Check if current path is active
  const isActivePath = (path) => {
    return location.pathname === path;
  };

  // Handle navigation
  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <div 
      className="
        fixed bottom-0 left-0 right-0 z-[120]
        bg-white border-t border-gray-200 shadow-lg
        md:hidden
      "
    >
      <div className="flex items-center justify-around py-2">
        {navItems.map((item) => {
          const IconComponent = item.icon;
          const isActive = isActivePath(item.path);
          
          return (
            <button
              key={item.id}
              onClick={() => handleNavigation(item.path)}
              className="flex flex-col text-[10px] md:text-sm items-center justify-center py-2 px-1.5 md:px-3 min-w-0 flex-1"
            >
              <div className="flex flex-col items-center space-y-1">
                <IconComponent 
                  className={`w-4 h-4 md:w-5 md:h-5 transition-colors duration-200 ${
                    isActive ? 'text-blue-600' : 'text-gray-500'
                  }`}
                />
                <span 
                  className={`text-[9px] md:text-sm font-medium transition-colors duration-200 ${
                    isActive ? 'text-blue-600' : 'text-gray-500'
                  }`}
                >
                  {item.label}
                </span>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNavbar;
